export default __webpack_public_path__ + "static/media/logo_hover.4269c036.png";